'use client';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';

import DynamicHideBlock from '@components/DynamicHideBlock';
import cn from './style.module.scss';
export default function AlGhadeerAvailability(
  props: MarketingPageComponentProps
) {
  const availabilitySection = props?.locale?.section?.find(
    (section: any) => section.type === 'availability' && section.enabled
  );
  if (!availabilitySection) return null;

  return (
    <Stack
      component="section"
      className={cn.alGhadeerAvailabilityWrapper}
      id="alGhadeerAvailability"
    >
      <Box className={cn.alGhadeerAvailabilityInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '100%', lg: '100%' }}
          flexGrow={1}
          paddingInline={{ xs: '1.25rem', md: '5%', lg: '10%' }}
        >
          <Box className={cn.alGhadeerAvailabilityBlock}>
            <DynamicHideBlock
              data={availabilitySection?.alghadeerAvailabilityBanner}
            >
              <Box className={cn.alGhadeerAvailabilityBanner}>
                <MobileBreakpoint>
                  <CustomImage
                    src={
                      availabilitySection?.alghadeerAvailabilityBanner?.mobile
                    }
                    alt={'AlGhadeer Availability Banner'}
                    width={768}
                    height={768}
                  />
                </MobileBreakpoint>
                <TabletBreakpoint>
                  <CustomImage
                    src={
                      availabilitySection?.alghadeerAvailabilityBanner?.tablet
                    }
                    alt={'AlGhadeer Availability Banner'}
                    width={768}
                    height={768}
                  />
                </TabletBreakpoint>
                <DesktopBreakpoint>
                  <CustomImage
                    src={
                      availabilitySection?.alghadeerAvailabilityBanner?.desktop
                    }
                    alt={'AlGhadeer Availability Banner'}
                    width={768}
                    height={768}
                  />
                </DesktopBreakpoint>
              </Box>
            </DynamicHideBlock>
            <Box className={cn.alGhadeerAvailabilityContent}>
              <List className={cn.alGhadeerAvailabilityDetails}>
                {availabilitySection?.alghadeerAvailabilityDetails?.map(
                  (detail: any, index: number) => (
                    <ListItem key={index} className={cn.availabilityDetailItem}>
                      <Box className={cn.availabilityDetailTitle}>
                        <ParallaxText
                          variant="p"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(detail.title)}
                        </ParallaxText>
                      </Box>
                      <Box className={cn.availabilityDetailLabel}>
                        <Box className={cn.availabilityLabelItem}>
                          <ParallaxText
                            variant="h4"
                            animationType="zoomIn"
                            animationDuration={500}
                          >
                            {ReactHtmlParser(detail.label)}
                          </ParallaxText>
                        </Box>
                      </Box>
                    </ListItem>
                  )
                )}
              </List>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
